
    <modal #modal [backdrop]="true" [closeOnOutsideClick]="true" (onClose)="saveAlertOptions()">
      <modal-content>
        <div class="voucher-alert">

          <img src="assets/shared/img/invitation.png" alt="Voucher liberado">

          <div class="title">Voucher liberado</div>

          <div class="description">
            O Voucher de R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}} está esperando por você!
          </div>

          <button class="btn" (click)="redirectToVouchers()">Ver voucher</button>
          <button class="btn link" (click)="closeModal()">Agora não</button>

        </div>
      </modal-content>
    </modal>
  